import React from 'react';
import sprintf from 'sprintf';
import SMClickOutsideObserver from 'lib/SMClickOutsideObserver';
import SMMapHelper from 'components/helpers/SMMapHelper';

class SMAutoCompleteRow extends React.Component {

  componentDidMount() {
    this.clickOutsideObserver = new SMClickOutsideObserver(this);
    this.clickOutsideObserver.attach(this.hide.bind(this));
    $(document).on("keydown", this.subscribeKeyEvent.bind(this));
  }

  componentWillUnmount() {
    this.clickOutsideObserver.detach();
    $(document).off("keydown", this.subscribeKeyEvent.bind(this));
  }

  itemDidSelect(i, e){
    e.preventDefault();
    if(this.props.delegate && typeof this.props.delegate.autoCompleteItemDidSelect === 'function'){
      this.props.delegate.autoCompleteItemDidSelect(i);
    }
  }

  hide() {
    if(this.props.delegate && typeof this.props.delegate.autoCompleteDidHide === 'function'){
      this.props.delegate.autoCompleteDidHide();
    }
  }

  subscribeKeyEvent(e) {
    if (!this.props.isOpen) return;
    let selectedRow = this.props.selectedRow;

    switch(e.keyCode) {
      case $.ui.keyCode.UP:
        if (selectedRow == null) selectedRow = this.props.items.length - 1;
        else if (selectedRow - 1 < 0) selectedRow = null;
        else selectedRow -= 1;
        if(this.props.delegate && typeof this.props.delegate.autoCompleteDidChangeRow === 'function'){
          this.props.delegate.autoCompleteDidChangeRow(selectedRow);
        }
        break;
      case $.ui.keyCode.DOWN:
        if (selectedRow == null) selectedRow = 0;
        else if (selectedRow + 1 == this.props.items.length) selectedRow = null;
        else selectedRow += 1;
        if(this.props.delegate && typeof this.props.delegate.autoCompleteDidChangeRow === 'function'){
          this.props.delegate.autoCompleteDidChangeRow(selectedRow);
        }
        break;
      case $.ui.keyCode.ENTER:
        if(this.props.delegate && typeof this.props.delegate.autoCompleteItemDidSelect === 'function'){
          this.props.delegate.autoCompleteItemDidSelect(selectedRow);
        }
        return false;
    }
  }

  render () {
    const layout = sprintf("%s autocomplete-layout",
      this.props.isTop ? "top__autocomplete-layout" : "site-header__autocomplete"
    );
    return (
      <div style={(this.props.isOpen && this.props.items.length > 0) ? {} : {display: "none"}} className="autocomplete">
        <div className={layout}>
          <div className="site-header__autocomplete-box">
            {(()=>{
              return this.props.items.map((item, currentRowIndex)=>{
                const className = this.props.selectedRow == currentRowIndex ?
                  "autocomplete-suggest autocomplete-suggest__active" : "autocomplete-suggest";
                const displayText = item.terms[0].value;
                const description = item.description;
                const iconClassName = SMMapHelper.isPlaceItem(item) ? "fa fa-map-marker" : "fa fa-building";
                return (
                  <a key={currentRowIndex} href="#" className={className} onClick={this.itemDidSelect.bind(this, currentRowIndex)}>
                    <div className="autocomplete-list">
                      <p className="autocomplete-text"><span className="autocomplete-history__map"><i className={iconClassName} />{displayText}<span className="autocomplete-history__description">{description}</span></span></p>
                    </div>
                  </a>
                );
              });
            })()}
          </div>
        </div>
      </div>
    );
  }
}
export default SMAutoCompleteRow;



// WEBPACK FOOTER //
// ./app/javascript/components/search/SMAutoCompleteRow.jsx